import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import { Div } from 'client/widget-components/basicComponents';
import Checkbox from 'client/widget-components/basicComponents/Checkbox/Checkbox';
import {
    CheckboxChoice,
    CheckboxLimitations,
} from 'client/widget-components/ecom/stores/types';
import { mergeResponsiveStyles } from 'client/widget-components/responsive-styles/responsiveStylesService';
import React, { ChangeEventHandler } from 'react';
import { TEXT_FIELD_DATA_GRABS } from '../../constants';
import { ProductCustomizationsStyles } from '../../types';

interface CheckboxCustomizationChoicesProps {
    choices?: CheckboxChoice[];
    limitations?: CheckboxLimitations;
    value: string[];
    onChange: ChangeEventHandler<HTMLInputElement>;
    styles?: ProductCustomizationsStyles;
}

const CheckboxCustomizationChoices = ({
    choices,
    value,
    styles,
    onChange,
}: CheckboxCustomizationChoicesProps) => {
    return (
        <Div
            styles={mergeResponsiveStyles([
                defaultContainerStyles,
                styles?.checkboxesContainer,
            ])}
            data-grab={TEXT_FIELD_DATA_GRABS.checkboxesContainerDataGrab}
        >
            {choices?.map((choice) => (
                <Checkbox
                    key={choice.identifier}
                    checked={value.includes(choice.identifier)}
                    name={choice.identifier}
                    onChange={onChange}
                    dataGrab={TEXT_FIELD_DATA_GRABS.checkboxDataGrab}
                    labelDataGrab={TEXT_FIELD_DATA_GRABS.checkboxLabelDataGrab}
                    checkedDataGrab={
                        TEXT_FIELD_DATA_GRABS.checkboxCheckedDataGrab
                    }
                    dataAuto={`customization-choice-${choice.label}`}
                    styles={{
                        checkboxRow: checkboxRowDefaultStyles,
                        checkbox: styles?.checkbox,
                        checkboxChecked: styles?.checkboxChecked,
                        checkboxLabel: styles?.checkboxLabel,
                    }}
                >
                    {choice.label}
                </Checkbox>
            ))}
        </Div>
    );
};

export default CheckboxCustomizationChoices;

const defaultContainerStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridTemplateRows: 'repeat(auto-fill, minmax(24px, 1fr))',
        gap: '8px',
    },
};

const checkboxRowDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
    },
};